import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import GithubContext from "../../context/github/githubContext";

const FeaturedDevelopersPage = () => {
  const { featuredUsers, featuredLoading } = useContext(GithubContext);

  useEffect(() => {
    document.title = "Featured Developers | GitHub Finder";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "Curated GitHub developer profiles — same list as the Featured Developers section on the home page."
      );
    }
  }, []);

  return (
    <div className="gf-page gf-featured-page">
      <div className="gf-container">
        <header className="gf-featured-page__head">
          <h1 className="gf-section-title">Featured Developers</h1>
          <p className="gf-muted gf-featured-page__intro">
            Usernames and profile URLs (loaded from your curated login list). Same profiles as on the{" "}
            <Link to="/">home page</Link>.
          </p>
        </header>

        <div className="gf-card gf-featured-page__table-wrap">
          {featuredLoading ? (
            <p className="gf-muted gf-featured-page__status">Loading profiles…</p>
          ) : featuredUsers.length === 0 ? (
            <p className="gf-muted gf-featured-page__status">
              No profiles loaded. Check <code>FEATURED_DEVELOPER_LOGINS</code> in{" "}
              <code>src/data/featuredDevelopersList.js</code> and GitHub API limits.
            </p>
          ) : (
            <table className="gf-featured-page__table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Username</th>
                  <th scope="col">Profile URL</th>
                </tr>
              </thead>
              <tbody>
                {featuredUsers.map((u, i) => (
                  <tr key={u.login}>
                    <td>{i + 1}</td>
                    <td>
                      <Link
                        to={`/user/${encodeURIComponent(u.login)}`}
                        className="gf-featured-page__login"
                      >
                        @{u.login}
                      </Link>
                    </td>
                    <td>
                      <a
                        href={u.html_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="gf-featured-page__url"
                      >
                        {u.html_url}
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeaturedDevelopersPage;
